<template>
  <div class="Risk" style="background-color: white">
    <div style="height: 58px;background-color: white;border-bottom: 2px solid #E1E1E1;">
      <el-col :span="19" :offset="5">
        <div style="float: left">
          <img           src="./images/logo.png"  />
<!--          ../../public/favicon.ico-->
        </div>
        <div style="margin-left: 160px">
          <span style="font-size: 28px;color: #2B78D9;margin-left: -60px;font-weight: bolder">通辽市能碳管理中心</span>
        </div>
      </el-col>

      <!--      <el-row>-->
      <!--        <el-col :span="16" :offset="5">-->
      <!--          <el-row>-->
      <!--            <el-col :span="2">-->
      <!--              <img src="./images/logo.svg"  />-->
      <!--            </el-col>-->
      <!--            <el-col :span="22">-->
      <!--              <div style="text-align: left">-->
      <!--                <span style="font-size: 28px;color: #2B78D9; font-weight: bolder;margin-left: 10px;">国家碳计量中心(内蒙古)碳达峰碳中和在线监测系统</span>-->
      <!--              </div>-->
      <!--            </el-col>-->
      <!--          </el-row>-->
      <!--        </el-col>-->
      <!--&lt;!&ndash;        <el-col :span="16">&ndash;&gt;-->
      <!--&lt;!&ndash;          &lt;!&ndash;       &ndash;&gt;&ndash;&gt;-->
      <!--&lt;!&ndash;          <div style="float: left">&ndash;&gt;-->
      <!--&lt;!&ndash;            <span style="font-size: 28px;color: #2B78D9; font-weight: bolder">国家碳计量中心(内蒙古)碳达峰碳中和在线监测系统</span>&ndash;&gt;-->
      <!--&lt;!&ndash;          </div>&ndash;&gt;-->
      <!--&lt;!&ndash;        </el-col>&ndash;&gt;-->
      <!--      </el-row>-->
    </div>

    <!--    border-top: 1px solid #E1E1E1;-->
    <!--    text-align: center;width: 1200px;height: 999px;border: 1px solid #EEEEEE;-->
    <div style="background: #FFFFFF;">
      <div style="width: 1200px;margin: auto;height: 15px;margin-top: 10px">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="font-size: 14px;">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/'+ pathName,query:{titleName:title,activeName:activeName}}">{{title}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{contentTitle}}</el-breadcrumb-item>
<!--          <el-breadcrumb-item v-if="title=='通知公告'">{{resultData.noticeTitle}}</el-breadcrumb-item>-->
<!--          <el-breadcrumb-item v-else>{{resultData.title}}</el-breadcrumb-item>-->
        </el-breadcrumb>
      </div>
      <div  v-if="title=='通知公告'" style="width: 1200px;border: 2px solid #EEEEEE;margin: auto;margin-top: 10px">
        <div style="font-size: 28px;font-weight: bold;width: 700px;text-align: center;margin: auto;height: 74px;">
          <sapn>
            {{contentTitle}}
            <!--            习近平主持召开新时代推动东北全面振兴座谈会强调:牢牢把握东北的重要使命 奋力谱写东北全面振兴新篇章-->
<!--            {{resultData.noticeTitle}}-->
          </sapn>
        </div>
        <div style="width: 500px;margin: auto;height: 20px;margin-top: 10px">
          <!--          jsonData-->
          <!--          {{resultData.createBy}}-->
<!--          <span style="float: left">作者:{{resultData.createBy}}</span>-->
<!--          <span style="margin-left: 100px">来源:</span>-->
<!--          {{resultData.source}}-->
          <sapn style="float: right">发布时间：{{contentDate.slice(0,10)}}</sapn>
<!--          <sapn style="float: right">发布时间：{{resultData.createDate}}</sapn>-->
        </div>
        <div style="height: 3px;width: 1113px;border-top: 2px solid #E7E7E7;margin: auto;margin-top: 10px"></div>
        <div style="width: 1100px;margin: auto;min-height: 700px">
          <div style="text-indent: 2em;margin-top: 20px">
<!--            {{resultData.content}} noticeContent-->
           <span v-html="resultData.content"></span>
<!--            <span >{{resultData.noticeContent}}</span>-->
          </div>
        </div>
      </div>
   
      <div v-else style="width: 1200px;border: 2px solid #EEEEEE;margin: auto;margin-top: 10px">
        <div style="font-size: 28px;font-weight: bold;width: 700px;text-align: center;margin: auto;height: 74px;">
          <sapn>
            <!--            习近平主持召开新时代推动东北全面振兴座谈会强调:牢牢把握东北的重要使命 奋力谱写东北全面振兴新篇章-->
<!--            {{resultData.title}}-->
            {{contentTitle}}
          </sapn>
        </div>
        <div style="width: 500px;margin: auto;height: 20px;margin-top: 10px">
<!--          jsonData-->
<!--          {{resultData.createBy}}-->
<!--          <span style="float: left">作者:{{resultData.source}}</span>-->
<!--          <span style="margin-left: 100px">来源:{{resultData.source}}</span>-->
<!--          {{resultData.createDate}}-->
<!--          {{jsonData.createDate}}-->
<!--          {{resultData.createDate.slice(0,4)}}-{{resultData.createDate.slice(4,6)}}-{{resultData.createDate.slice(6,8)}}-->
          <sapn style="float: right">发布时间：{{contentDate.slice(0,10)}}</sapn>
<!--          <sapn style="float: right">发布时间：{{resultData.publishDate.slice(0,4)}}-{{resultData.publishDate.slice(4,6)}}-{{resultData.publishDate.slice(6,8)}}</sapn>-->
        </div>
        <div style="height: 3px;width: 1113px;border-top: 2px solid #E7E7E7;margin: auto;margin-top: 10px"></div>
        <div style="width: 1100px;margin: auto;min-height: 700px">
          <div style="text-indent: 2em;margin-top: 20px">
<!--            <span>{{resultData.content}}</span>-->
            <span v-html="resultData.content"></span>
<!--            {{resultData.content}}-->
<!--            <span v-html="resultData.noticeContent"></span>-->
<!--                        新华社哈尔滨9月9日电 中共中央总书记、国家主席、中央军委主席习近平7日下午在黑龙江省哈尔滨市主持召开新时代推动东北全面振兴座谈会并发表重要讲话。-->
<!--                        他强调，新时代新征程推动东北全面振兴，要贯彻落实党的二十大关于推动东北全面振兴实现新突破的部署，-->
<!--                        完整准确全面贯彻新发展理念，牢牢把握东北在维护国家“五大安全”中的重要使命，牢牢把握高质量发展这个首要任务和构建新发展格局这个战略任务，-->
<!--                        统筹发展和安全，坚持目标导向和问题导向相结合，坚持锻长板、补短板相结合，坚持加大支持力度和激发内生动力相结合，-->
<!--                        咬定目标不放松，敢闯敢干加实千，努力走出一条高质量发展、可持续振兴的新路子，奋力谱写东北全面振兴新篇章。-->
          </div>
<!--                    <div style="text-indent: 2em;margin-top: 20px">-->
<!--                      9月7日下午，中共中央总书记、国家主席、中央军委主席习近平在黑龙江省哈尔滨市主持召开新时代推动东北全面振兴座谈会并发表重要讲话。新华社记者 谢环驰 摄-->
<!--                    </div>-->
<!--                    <div style="text-indent: 2em;margin-top: 20px">-->
<!--                      中共中央政治局常委、中央办公厅主任蔡奇，中共中央政治局常委、国务院副总理工薛祥出席座谈会。-->
<!--                    </div>-->
<!--                    <div style="text-indent: 2em;margin-top: 20px">-->
<!--                      座谈会上，国家发展改革委主任郑栅洁、辽宁省委书记郝鹏、吉林省委书记景俊海、黑龙江省委书记许勤、内蒙古自治区党委书记孙绍聘先后发言，就推动东北全面振兴汇报工作情况、提出意见建议。-->
<!--                    </div>-->
<!--                    <div style="text-indent: 2em;margin-top: 20px">-->
<!--                      9月7日下午，中共中央总书记、国家主席、中央军委主席习近平在黑龙江省哈尔滨市主持召开新时代推动东北全面振兴座谈会并发表重要讲话。新华社记者殷博古 摄-->
<!--                    </div>-->
<!--                    <div style="text-indent: 2em;margin-top: 20px">-->
<!--                      听取大家发言后，习近平发表了重要讲话。他强调，2018年9月在沈阳召开深入推进东北振兴座谈会以来，东北三省及内蒙古在推动东北振兴方面取得新进展新成效，-->
<!--                      国家粮食安全“压舱石”作用进一步夯实，产业安全基础不断巩固，能源安全保障作用不断强化，生态安全屏障不断筑牢，国防安全保障能力稳》提升，改革开放呈现新气象。-->
<!--                    </div>-->
<!--                    <div style="text-indent: 2em;margin-top: 20px">-->
<!--                      习近平指出，东北资源条件较好，产业基础比较雄厚，区位优势独特，发展潜力巨大。当前，推动东北全面振兴面临新的重大机遇:实现高水平科技自立自强、-->
<!--                      有利于东北把科教和产业优势转化为发展优势，构建新发展格局，进一步凸显东北的重要战略地位，推进中国式现代化，需要强化东北的战略支撑作用。-->
<!--                      相信在强国建设、民族复兴新征程中，东北一定能够重振雄风、再创佳绩。-->
<!--                    </div>-->
<!--                    <div style="text-indent: 2em;margin-top: 20px">-->
<!--                      习近平强调，要以科技创新推动产业创新，加快构建具有东北特色优势的现代化产业体系。推动东北全面振兴，根基在实体经济，关键在科技创新，方向是产业升级、-->
<!--                      要牢牢把住自主创新这个“生皇子”，在巩固存量，拓展增量、延伸产业链、提高附加值上下功夫，加快传统制造业数字化，网终化，智能化改造，推动产业销向上下游延伸，-->
<!--                      形成较为完善的产业链和产业集群。主动对接国家战略需求，整合和优化科教创新资源，加大研发投入，掌握更多关键核心技术。积极培育产业园区，加强对口合作，加快科研成果落地转化。-->
<!--                      积极培育新能源、新材料、先进制造、电子信息等战略性新兴产业，积极培育未来产业，加快形成新质生产力，增强发展新动部。加快发展风电、光电、核电等清洁源，-->
<!--                      建设风光火核储一体化自源基地。加强生态资源保护利用，依社东北的生态境和生物资源优势，发展现代生物、大数据等新兴特色产业、发展冰雪经济和海洋经济。-->
<!--                      继续深化国有企业改革，实施国有企业振兴专项行动、提高国有企核心竞争力，推动国有资本向重要行业和关键领域集中，强化战略支撑作用。创新央地合作模式，保进央地融合发展，-->
<!--                      更好带动地方经济发展。支持、鼓励引导民营经济健康发展，实施更多面向中小企业的普惠性政策，形成多种所有制企业共同发展的良好局面。-->
<!--                    </div>-->
        </div>
      </div>
     
      <div style="width: 1200px;margin: auto;height: 50px;margin-top: 10px">
        <button @click="backToTable" style="color: #2B78D9;background-color: white;border: 2px solid #2B78D9;font-size: 18px;cursor: pointer;">
          返回列表
        </button>
      </div>
    </div>

    <!--    class="container"-->

    <!--    <div style="min-height: 1200px;width:1000px;border: 1px;text-align: center">-->
    <!--      -->
    <!--    </div>-->
  </div>

  <!--  <div class="Risk">-->
  <!--    <el-breadcrumb separator-class="el-icon-arrow-right">-->
  <!--      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
  <!--      <el-breadcrumb-item>通知公告</el-breadcrumb-item>-->
  <!--      <el-breadcrumb-item>习近平主持召开新时代推动东北全面振兴座谈会强调:牢牢把握东北的重要使命 力谱写东北全面振兴新篇章</el-breadcrumb-item>-->
  <!--    </el-breadcrumb>-->
  <!--  </div>-->
</template>
<script>
import data from '@/assets/test.json';
import * as Setting from "@/setting";
import {getHalo} from "@/setting";
import axios from "axios";
const config = {
  headers: {
    Authorization: "Bearer pat_eyJraWQiOiJiOFJTWW90SWdrSERaWTZUWEt4X3NVbjcxRy1XRXp2THQ1UkJsTGVrbkJJIiwiYWxnIjoiUlMyNTYifQ.eyJpc3MiOiJodHRwOi8vMS4yNi4yMzYuMTgzOjE4MDA0LyIsInN1YiI6ImhhbG9hZG1pbiIsImlhdCI6MTc2MTEwODc3MywianRpIjoiZTQwNDQ5ZjMtMGI4ZS0xOGE3LWQ0NzUtZWEwZTk3MzlmZTNhIiwicGF0X25hbWUiOiJwYXQtaGFsb2FkbWluLW9QREFXIn0.bU5HcDqLvYyqtvcWl7qKoIGHAqIup2RuM43LW0aY_1frGQLq0OlCvJ6jH3fpBwuTygbeYmjB-uzYnJLgYeERNL4uvl6EAdhRcBkjk9AwNZwp3CILrg8IadsmdbU3mlLpcylHXSUbG7c-Q4rpTJ6nMPyP0AYsH2qk8QwR8p_rgjYOTX8vpyXeNecad0Gl1XlKRWrVOdKg15SuQM3Uy_IFH6-jPBJZihBPjmQlpLgngP35dLUQ6CKWkGw2OsYowg9qHiORXJa9F7OQdUdXOP9SF5_mh507kKItGibfLd8pL3WfTPbIq665sAJ3x43L1n10GXltKT4FS4Qe4L0-kNIuTiKR1hvZ6NY1tvvjc2JRdWrtL8KF9uhCaiyaTrhz4aKRAo5Q-7csTc5LENrcoySn5kdpaOqlLLV-Xk-lV1hxarCoYnp_B2mP0Yvu-lhJzJPmMIqmDCDriGB69wObpTiIVoEo7WpkM5sj6kOrNiuSo653TDG0vtokIWP3FR0eQ1iWK3-Ae_gNTfJgVY7rxkvrLNk0PacXm8gPkNwAA_gNJNlSherIB_QJDFSnxGH4M5EovtDeD4dK0UDJ-xuwV0d_bVMfUzU0colJkXHrvp3b0gxGw0pzitXhoLJIgVbsJisH3MOzYR8QqG4N6zHhiqrEptcxaZMFwTvRB40QkrA4d9o", // 设置认证令牌
    // 'Authorization': 'Basic aGFsb2FkbWluOkNhUmJvbkAyNC4y', // 设置认证令牌
    // 'Authorization': 'Basic c3ViaW5naGU6MTIzNDU2', // 设置认证令牌
    // 'Authorization': 'Basic YWRtaW46Rmd3XzIwMjQh', // 设置认证令牌
    'Content-Type': 'application/json' // 设置内容类型为JSON
  }
};
export default {
  data() {
    return {
      resultData:{},
      jsonData: data,
      title:this.$route.query.titleName,
      activeName: this.$route.query.activeName,
      resultIndex: this.$route.query.resultIndex,
      contentTitle:this.$route.query.contentTitle,
      contentDate:this.$route.query.contentDate,
      activeId: 1,
      pathName:'tableDetail',
      tabPosition: "left",
      tabList: [
        { id: 1, job: "分类系统" },
        { id: 2, job: "查询系统" },
        { id: 3, job: "小贴士" },
      ],
    };
  },
  created() {
    this.getData();
    this.getData1();
    this.getData2();
    this.getData3();
    this.getData4();
    // let that =this;
    // if(that.titleName=='通知公告'){
    //   that.getData();
    // }else if(that.titleName=='要闻动态'){
    //   that.getData1();
    // }else if(that.titleName=='网上公示'){
    //   that.getData2();
    // }else if(that.titleName=='减排政策'){
    //   that.getData3();
    // }
    this.$emit('header',false);
  },
  methods: {
    getData3(){
      let that =this;
      if(that.$route.query.titleName=='政策解读'){
        axios.get(Setting.getHalo()+'/v1alpha1/posts/'+that.$route.query.contentId+'/head-content',
            config ).then(response => {
          response.data.content = response.data.content.replace(/src="\/upload/g, 'src="https://ntgl.tlsyjxndc.com:18004/upload');
          response.data.raw = response.data.raw.replace(/src="\/upload/g, 'src="https://ntgl.tlsyjxndc.com:18004/upload');
          that.resultData=response.data;
        });
      }

      // axios.defaults.headers.common[ 'Cache-Control' ] = 'no-cache';
      // axios.get("/door/chinanecc_zcfg.json", {params: {}}).then(function(response) {
      //   if(that.$route.query.titleName=='政策解读'){
      //     that.resultData=response.data[that.resultIndex];
      //   }
      // })
    },
    getData2(){
      let that =this;
      if(that.$route.query.titleName=='案例分析'){
        axios.get(Setting.getHalo()+'/v1alpha1/posts/'+that.$route.query.contentId+'/head-content',
            config ).then(response => {
          response.data.content = response.data.content.replace(/src="\/upload/g, 'src="https://ntgl.tlsyjxndc.com:18004/upload');
          response.data.raw = response.data.raw.replace(/src="\/upload/g, 'src="https://ntgl.tlsyjxndc.com:18004/upload');
          that.resultData=response.data;
        });
      }
      // axios.defaults.headers.common[ 'Cache-Control' ] = 'no-cache';
      // axios.get("/door/chinanecc_jnyj.json", {params: {}}).then(function(response) {
      //   if(that.$route.query.titleName=='网上公示'){
      //     that.resultData=response.data[that.resultIndex];
      //   }
      // })
    },
    getData1(){
      let that =this;
      if(that.$route.query.titleName=='双碳要闻'){
        axios.get(Setting.getHalo()+'/v1alpha1/posts/'+that.$route.query.contentId+'/head-content',
            config ).then(response => {
          console.log("双碳要闻",response);
           response.data.content = response.data.content.replace(/src="\/upload/g, 'src="https://ntgl.tlsyjxndc.com:18004/upload');
          response.data.raw = response.data.raw.replace(/src="\/upload/g, 'src="https://ntgl.tlsyjxndc.com:18004/upload');
          that.resultData=response.data;
        });
      }
     
    },
    getData(){
      let that =this;
      if(that.$route.query.titleName=='技术共享'){
        axios.get(Setting.getHalo()+'/v1alpha1/posts/'+that.$route.query.contentId+'/head-content',
            config ).then(response => {
          response.data.content = response.data.content.replace(/src="\/upload/g, 'src="https://ntgl.tlsyjxndc.com:18004/upload');
          response.data.raw = response.data.raw.replace(/src="\/upload/g, 'src="https://ntgl.tlsyjxndc.com:18004/upload');
          that.resultData=response.data;
          console.log("通知公告测试",response.data);
        });
      }
     
    },
    getData4(){
      let that =this;
      if(that.$route.query.titleName=='平台咨询'){
        axios.get(Setting.getHalo()+'/v1alpha1/posts/'+that.$route.query.contentId+'/head-content',
            config ).then(response => {
          response.data.content = response.data.content.replace(/src="\/upload/g, 'src="https://ntgl.tlsyjxndc.com:18004/upload');
          response.data.raw = response.data.raw.replace(/src="\/upload/g, 'src="https://ntgl.tlsyjxndc.com:18004/upload');
          that.resultData=response.data;
          console.log("平台咨询",response.data);
        });
      }
     
    },
    backToTable(){
      console.log(this.$route.query.resultData);
      console.log(this.resultData);
      this.$router.push("/wordDetail");
      // title
      this.$router.push({
        path: this.pathName,
        query: {titleName:this.title,activeName:this.activeName}
      })
    },
  },

};
</script>
<style lang="less" scoped>
.Risk {
  background: #f2f2f2;
  //width: 1200px;
  margin: 0 auto;
  margin-bottom: 40px;
}
.container {
  width: 1200px;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 0 auto;
  margin-top: 20px;
}
.box {
  margin-top: 15px;
  width: 100%;
  height: 12px;
}
/deep/ .el-breadcrumb {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  line-height: 12px;
  float: left;
}
.dangqian {
  float: left;
}
/deep/.el-breadcrumb__inner {
  font-weight: 400 !important;
}
.red {
  color: #dd2126;
}

.isActive {
  background: #fce9ea;
}
.left {
  width: 180px;
  height: 267px;
  background-color: white;
}
.smallBox {
  width: 180px;
  height: 52px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 52px;
  text-align: center;
}
.top {
  margin-top: 24px;
  width: 180px;
  height: 52px;
  line-height: 52px;
  display: flex;
  justify-content: flex-start;
  background-color: #dd2126;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.yi {
  margin-left: 10px;
  font-size: 16px;
  line-height: 50px;
  color: white;
}
.right {
  margin-left: 20px;
  width: 1000px;
  min-height: 712px;
  background-color: white;
  padding: 41px 40px;
  box-sizing: border-box;
}
i {
  margin-left: 10px;
  width: 18px;
  height: 18px;
  color: white;
}
.blue {
  color: #2B78D9;
}
</style>
